import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import {
    MemberSearchInput,
    MemberSearchText,
} from '../../styles/TextStyles';
import { BaseButton } from "../../styles/ButtonStyles";
import Loader from "../Loader";
import urls from "../../api/urls.json";
import { FlexWrapper, } from "../../styles/WrapperStyles";
import { RowTextStyle } from '../../styles/TextStyles';
import MemberDetailedView from './MemberDetailedView';
import PageModal from '../modals/PageModal';
import { authorizedHttpGet } from '../../api/httpCalls';
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/Member.css';


const ProfileItemWrapper = styled(FlexWrapper)`
  margin-top: 15px;
  cursor: pointer;
  align-items: center;
`;

const Par = styled.div`
  display: flex;
  width: 100%;
  height: max-content;
  marggin-left: 200px
`;

const RightDiv = styled.div`
  padding: 0px 20px;
  height: max-content;
  border-radius: 30px;
  background-color: #f8f8fa;
`;

const HeaderWrapper = styled(FlexWrapper)`
    // display: inline;
    margin-left: 20px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;
const HeaderWrapperPrevious = styled(FlexWrapper)`
    // display: inline;
    margin-left: 200px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const HeaderWrapperNext = styled(FlexWrapper)`
    // display: inline;
    margin-left: 20px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const Memberboard = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [ref, setRef] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [firstName, setFirstName] = useState('')
    const [age, setAge] = useState('')
    const [about, setAbout] = useState('')
    const [invoiceId, setInvoiceId] = useState('')
    const [transactionId, setTransactionId] = useState('')
    const [uniqueIdentifierId, setUniqueIdentifierId] = useState('')
    const [loading, setLoading] = useState(false);
    const [userId, setUserId] = useState('');
    const [profiles, setProfiles] = useState([]);
    const [profileDetailedView, toggleProfileDetailedView] = useState(false);
    const [detailedViewRef, setDetailedViewRef] = useState(null);
    const [displayPageModal, setDisplayPageModal] = useState(false);
    const apiPageChange = React.useRef(1);
    const totalPagesApi = React.useRef(1);

    const resetSearch = () => {
        setUserId('');
        setRef('');
        setEmail('');
        setPhone('');
        setFirstName('');
        setAge('');
        setAbout('');
        setInvoiceId('');
        setTransactionId('');
        setUniqueIdentifierId('');
        setProfiles([]);
        totalPagesApi.current = 1;
        toggleProfileDetailedView(false);
        apiPageChange.current = 1;
    }

    const handleLeftNavAppChange = (name) => {
        resetSearch();
        setAppName(name)
    };

    useEffect(() => {
        resetSearch();
    }, [appName]);

    const fetchData = async () => {
        setLoading(true);
        let response = await authorizedHttpGet(`${urls.GET_MEMBERBOAD_SEARCH}?page=${1}&ref=${ref}&email=${email}&phone_number=${phone}&first_name=${firstName}&age=${age}&about=${about}&user_id=${userId}&invoice_id=${invoiceId}&transaction_id=${transactionId}&unique_identifier=${uniqueIdentifierId}`, {});
        if (response.status) {
            setProfiles(response.data.profile_list)
            totalPagesApi.current = response.data.total_pages;
            apiPageChange.current = 1;
            setDisplayPageModal(false);
        }
        setLoading(false);
    }

    const goToPage = async (pageNumber) => {
        if (pageNumber > totalPagesApi.current || pageNumber < 1) {
            alert('Invalid page number');
            return;
        }
        apiPageChange.current = pageNumber;
        setLoading(true);
        let response = await authorizedHttpGet(`${urls.GET_MEMBERBOAD_SEARCH}?page=${apiPageChange.current}&ref=${ref}&email=${email}&phone_number=${phone}&first_name=${firstName}&age=${age}&about=${about}&invoice_id=${invoiceId}&transaction_id=${transactionId}&unique_identifier=${uniqueIdentifierId}`, {});
        if (response.status) {
            setProfiles(response.data.profile_list)
            totalPagesApi.current = response.data.total_pages;
            apiPageChange.current = response.data.page;
            setDisplayPageModal(false);
        }
        setLoading(false);
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                fetchData();
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });

    const closeDetailedView = () => {
        setDetailedViewRef(null);
        toggleProfileDetailedView(false)
    }

    return (
        <div className='App'>
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Memberboard'} />
            {
                profileDetailedView ? <MemberDetailedView detailedViewRef={detailedViewRef} closeDetailedView={closeDetailedView} viewType={"MemberBoard"} /> :
                    <Par className='marginLeft200'>
                        {loading && <Loader loading={loading} />}
                        {displayPageModal && <PageModal goToPage={goToPage} page={apiPageChange.current} closeModal={() => setDisplayPageModal(false)} />}
                        <div className='width100'>
                            <FlexWrapper className='marginTop25'>
                                <HeaderWrapperPrevious onClick={() => goToPage(apiPageChange.current - 1) } className='cursorPointer' > &lt; </HeaderWrapperPrevious>
                                <HeaderWrapper onClick={() => setDisplayPageModal(true)} className='cursorPointer'>
                                    <HeaderSelected>{apiPageChange.current}</HeaderSelected>
                                    <HeaderSelected className='marginLeft10'>{totalPagesApi.current}</HeaderSelected>
                                </HeaderWrapper>
                                <HeaderWrapperNext onClick={() => goToPage(apiPageChange.current + 1) } className='cursorPointer' >  > </HeaderWrapperNext>
                            </FlexWrapper>
                            {profiles.map((profile, pos) => {
                                return (
                                    <ProfileItemWrapper
                                        key={profile.ref}
                                        onClick={() => {
                                            setDetailedViewRef(profile.ref);
                                            toggleProfileDetailedView(true);
                                        }}
                                    >
                                        <RowTextStyle grey width="150px">
                                            {profile.ref}
                                        </RowTextStyle>
                                        <RowTextStyle grey width="150px">
                                            {profile.name}
                                        </RowTextStyle>
                                        <RowTextStyle grey width="300px">
                                            {profile.email}
                                        </RowTextStyle>
                                        <RowTextStyle grey width="150px">
                                            {profile.phone_code}
                                            {profile.phone_number}
                                        </RowTextStyle>
                                        <RowTextStyle grey width="150px">
                                            {profile.profile_state}
                                        </RowTextStyle>
                                    </ProfileItemWrapper>
                                );
                            })}
                        </div>
                        <RightDiv>
                            <MemberSearchText>Ref</MemberSearchText>
                            <MemberSearchInput value={ref} onChange={(e) => setRef(e.target.value)} />
                            <MemberSearchText>UserId</MemberSearchText>
                            <MemberSearchInput value={userId} onChange={(e) => setUserId(e.target.value)} />
                            <MemberSearchText>Email</MemberSearchText>
                            <MemberSearchInput value={email} onChange={(e) => setEmail(e.target.value)} />
                            <MemberSearchText>Phone Number</MemberSearchText>
                            <MemberSearchInput value={phone} onChange={(e) => setPhone(e.target.value)} />
                            <MemberSearchText>First Name</MemberSearchText>
                            <MemberSearchInput value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                            <MemberSearchText>Age</MemberSearchText>
                            <MemberSearchInput value={age} onChange={(e) => setAge(e.target.value)} />
                            <MemberSearchText>About</MemberSearchText>
                            <MemberSearchInput value={about} onChange={(e) => setAbout(e.target.value)} />
                            <MemberSearchText>Invoice Id</MemberSearchText>
                            <MemberSearchInput value={invoiceId} onChange={(e) => setInvoiceId(e.target.value)} />
                            <MemberSearchText>Transaction ID</MemberSearchText>
                            <MemberSearchInput value={transactionId} onChange={(e) => setTransactionId(e.target.value)} />
                            <MemberSearchText>Device Id</MemberSearchText>
                            <MemberSearchInput value={uniqueIdentifierId} onChange={(e) => setUniqueIdentifierId(e.target.value)} />
                            <div>
                                <BaseButton onClick={() => fetchData()}>Search</BaseButton>
                            </div>
                        </RightDiv>
                    </Par>
            }
        </div>
    )
};

export default Memberboard;